export const NOTIFICATION_OPTIONS_TEST_ID = 'NotificationOptions';
export const NOTIFICATIONS_PREFERENCES_ROW_TEST_ID = 'NotificationPreferencesRow';
export const NOTIFICATIONS_SUBSCRIPTION_ROW_TEST_ID = 'NotificationSubscriptionRow';
